import React from 'react';
import ReactDOM from 'react-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import './index.less';
import 'antd/dist/antd.css'
import "antd-mobile/dist/antd-mobile.min.css"
import App from './App';
import {Provider} from "react-redux";
import reportWebVitals from './reportWebVitals';
import './assets/style/frame.less'
import moment from 'moment';
import 'moment/locale/zh-cn';
import store from "./store"
moment.locale('zh-cn');

ReactDOM.render(
	<ConfigProvider locale={zhCN}>
		<Provider store={store}>
		<App />
		</Provider>
	</ConfigProvider>,
    
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
